import { useEffect, useState } from 'react';

export function useMarketTimer() {
  const [state, setState] = useState({ label: 'MARKET', countdown: '--:--:--' });

  useEffect(() => {
    const tick = () => {
      const n = new Date();
      const h = n.getHours();
      const m = n.getMinutes();
      let target = new Date(n);
      let label = 'MARKET';

      if (h < 9 || (h === 9 && m < 15)) {
        target.setHours(9, 15, 0, 0);
        label = 'OPENS IN';
      } else if (h > 15 || (h === 15 && m >= 30)) {
        target.setDate(target.getDate() + 1);
        target.setHours(9, 15, 0, 0);
        label = 'OPENS IN';
      } else {
        target.setHours(15, 30, 0, 0);
        label = 'CLOSES IN';
      }

      const d = target - n;
      if (d > 0) {
        const hh = Math.floor(d / 3600000);
        const mm = Math.floor((d % 3600000) / 60000);
        const ss = Math.floor((d % 60000) / 1000);
        setState({
          label,
          countdown: `${String(hh).padStart(2, '0')}:${String(mm).padStart(2, '0')}:${String(ss).padStart(2, '0')}`,
        });
      }
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  return state;
}